const PRIMARY_COLOR = "#" + process.env.REACT_APP_PRIMARY_COLOR;
const PLATFORM = process.env.REACT_APP_PLATFORM;
const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME;
const PLATFORM_LOGO = process.env.REACT_APP_PLATFORM_LOGO;
const FAVICON = process.env.REACT_APP_FAVICON;

export { PRIMARY_COLOR, PLATFORM, PLATFORM_NAME, PLATFORM_LOGO, FAVICON };
